export default __webpack_public_path__ + "static/media/sameer.704741da.png";